<template>
  <b-form-group :invalid-feedback="errorTxt" :state="state">
    <b-input-group :prepend="label?label:$t('gateway')">
      <b-form-select
          v-model="inputVal"
          :options="options"
          :state="state"
          :disabled="disabled">
      </b-form-select>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    model: Object,
    attribute: {type: String, default: 'gateway'},
    service: {type: String, default: '/gateway'},
    label: String,
    errors: Array,
    disabled: Boolean
  },
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      options: [],
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load() {
      this.options = [
        {value: null, text: this.$t('selectGateway')}
      ];
      this.$bgService.get(this.service, {
        params: {
          page: 1,
          pageSize: 1000,
          status: 0,
          host: this.host
        }
      }).then(response => {
        let found = false;
        response.data.docs.forEach(item => {
          this.options.push({value: item._id, text: `${item.name}`});
          if (item._id === this.model[this.attribute]) {
            found = true;
          }
        });
        if (found) {
          this.inputVal = this.model[this.attribute] ? this.model[this.attribute] : null;
        } else {
          this.inputVal = null;
        }
      });
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectGateway: 'Select gateway',
      },
      vi: {
        selectGateway: 'Chọn gateway',
      }
    }
  }
}
</script>